import React from 'react';

import { AritoFormV2, AritoIcon, BottomActionBarV2, DialogV2 } from '@/components/custom/erp';
import { FormMode } from '@/types/form';

import { ToolEquipmentChangeReasonFormValues, toolEquipmentChangeReasonSchema } from '../schema';
import type { LyDoTangGiamCCDC } from '@/types/schemas';
import { BasicInfoTab } from './BasicInfoTab';

interface FormDialogProps {
  open: boolean;
  mode: FormMode;
  initialData?: ToolEquipmentChangeReasonFormValues;
  onClose: () => void;
  selectedObj?: LyDoTangGiamCCDC | null;
  onSubmit: (data: ToolEquipmentChangeReasonFormValues) => Promise<void>;
  onAddButtonClick?: () => void;
  onEditButtonClick?: () => void;
  onDeleteButtonClick?: () => void;
  onCopyButtonClick?: () => void;
}

export const FormDialog: React.FC<FormDialogProps> = ({
  open,
  mode,
  initialData,
  onClose,
  selectedObj,
  onSubmit,
  onAddButtonClick,
  onEditButtonClick,
  onDeleteButtonClick,
  onCopyButtonClick
}) => {
  const getDialogTitle = () => {
    switch (mode) {
      case 'add':
        return 'Thêm lý do tăng giảm CCDC';
      case 'edit':
        return 'Sửa lý do tăng giảm CCDC';
      case 'view':
        return 'Xem lý do tăng giảm CCDC';
      default:
        return 'Lý do tăng giảm CCDC';
    }
  };

  const handleSubmit = async (data: ToolEquipmentChangeReasonFormValues) => {
    try {
      await onSubmit(data);
      onClose();
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  return (
    <>
      <DialogV2
        open={open}
        onClose={onClose}
        title={getDialogTitle()}
        maxWidth='lg'
        disableBackdropClose={true}
        disableEscapeKeyDown={true}
        titleIcon={<AritoIcon icon={12} className='mx-2' />}
      >
        <AritoFormV2<ToolEquipmentChangeReasonFormValues>
          mode={mode}
          initialData={initialData}
          schema={toolEquipmentChangeReasonSchema}
          onSubmit={handleSubmit}
          onClose={onClose}
          hasAritoActionBar={false}
          className='w-full'
          headerFields={<BasicInfoTab formMode={mode} />}
          bottomBar={
            <BottomActionBarV2
              mode={mode}
              onAdd={onAddButtonClick}
              onEdit={onEditButtonClick}
              onDelete={onDeleteButtonClick}
              onCopy={onCopyButtonClick}
              onClose={onClose}
            />
          }
        />
      </DialogV2>
    </>
  );
};
